export default {
  'login.title': 'เข้าสู่ระบบผู้ดูแล',
  'login.subtitle': 'กรุณาเข้าสู่ระบบด้วยบัญชีผู้ดูแลที่ได้รับจากผู้ดูแลระบบหลัก',
  'login.email': 'ชื่อผู้ใช้ / อีเมล',
  'login.emailPlaceholder': 'กรอกชื่อผู้ใช้หรืออีเมล',
  'login.password': 'รหัสผ่าน',
  'login.passwordPlaceholder': 'กรอกรหัสผ่าน',
  'login.submit': 'เข้าสู่ระบบ',
  'login.loading': 'กำลังเข้าสู่ระบบ...',
  'login.failed': 'เข้าสู่ระบบล้มเหลว',
  'login.networkError': 'ข้อผิดพลาดเครือข่าย',
  'login.unknownError': 'ข้อผิดพลาดที่ไม่ทราบ',
  'login.emptyFields': 'กรุณากรอกชื่อผู้ใช้และรหัสผ่าน',
  'login.showPassword': 'แสดงรหัสผ่าน',
  'login.hidePassword': 'ซ่อนรหัสผ่าน',
  'login.noSelfRegister': 'แพลตฟอร์มนี้ไม่เปิดให้ลงทะเบียนด้วยตนเอง กรุณาติดต่อผู้ดูแลระบบหลักเพื่อขอบัญชี',
  'login.footerText': 'แพลตฟอร์มจัดการหลายผู้เช่า',
  'login.brandTitle1': 'คอนโซล',
  'login.brandTitle2': 'หลายผู้เช่า',
  'login.brandSlogan': 'จัดการผู้เช่า ผู้ใช้ ทรัพยากร และนโยบายการเรียกเก็บเงินแบบรวมศูนย์ เพื่อการดำเนินงานที่มีประสิทธิภาพและปลอดภัยยิ่งขึ้น',
  'login.feature1Title': 'การควบคุมการเข้าถึง',
  'login.feature1Desc': 'การควบคุมการเข้าถึงระดับองค์กรและบันทึกตรวจสอบ',
  'login.feature2Title': 'การแยกข้อมูล',
  'login.feature2Desc': 'การแยกข้อมูลหลายผู้เช่าและการจัดการโควต้า',
  'login.feature3Title': 'การตรวจสอบ',
  'login.feature3Desc': 'แดชบอร์ดตรวจสอบแบบเรียลไทม์และการวิเคราะห์รายงาน',
  'sidebar.home': 'แดชบอร์ด',
  'sidebar.users': 'ผู้ใช้และสิทธิ์',
  'sidebar.resources': 'ฟีเจอร์และทรัพยากร',
  'sidebar.tenants': 'จัดการผู้เช่า',
  'sidebar.audit': 'บันทึกตรวจสอบ',
  'sidebar.reports': 'รายงาน',
  'sidebar.settings': 'ตั้งค่าระบบ',
  'sidebar.admin': 'ผู้ดูแลระบบ',
  'header.search': 'ค้นหาผู้เช่า ผู้ใช้ ทรัพยากร...',
  'header.notifications': 'การแจ้งเตือน',
  'header.viewAll': 'ดูทั้งหมด',
  'header.profile': 'โปรไฟล์',
  'header.settings': 'ตั้งค่า',
  'header.logout': 'ออกจากระบบ',
  'header.notif.newTenant': 'ผู้เช่าใหม่ลงทะเบียน',
  'header.notif.newTenantMsg': 'บริษัท Tech Innovation ลงทะเบียนแล้ว',
  'header.notif.apiWarning': 'คำเตือนการใช้ API',
  'header.notif.apiWarningMsg': 'ผู้เช่า T002 ใกล้ถึงขีดจำกัดโควตา',
  'header.notif.systemUpdate': 'อัปเดตระบบ',
  'header.notif.systemUpdateMsg': 'บำรุงรักษาระบบคืนนี้',
  'header.notif.5minAgo': '5 นาทีที่แล้ว',
  'header.notif.1hourAgo': '1 ชั่วโมงที่แล้ว',
  'header.notif.3hoursAgo': '3 ชั่วโมงที่แล้ว',
  'home.title': 'ภาพรวมการจัดการ',
  'home.subtitle': 'ยินดีต้อนรับกลับ นี่คือแพลตฟอร์มจัดการหลายผู้เช่า',
  'home.totalTenants': 'ผู้เช่าทั้งหมด',
  'home.totalUsers': 'ผู้ใช้ทั้งหมด',
  'home.apiCalls': 'การเรียก API',
  'home.totalRevenue': 'รายได้ทั้งหมด',
  'home.totalSkills': 'ทักษะทั้งหมด',
  'home.chatSessions': 'เซสชันแชท',
  'home.totalMessages': 'ข้อความทั้งหมด',
  'home.systemHealth': 'สุขภาพระบบ',
  'home.active': 'ใช้งาน',
  'home.activeShort': 'ใช้งาน',
  'home.thisMonth': 'เดือนนี้',
  'home.published': 'เผยแพร่แล้ว',
  'home.cumulative': 'สะสม',
  'home.running': 'ทำงานปกติ',
  'home.vsLastMonth': 'เทียบเดือนก่อน',
  'home.apiTrend': 'แนวโน้มการใช้ API',
  'home.revenueTrend': 'แนวโน้มรายได้',
  'home.quickAccess': 'เข้าถึงด่วน',
  'home.recentActivity': 'กิจกรรมล่าสุด',
  'home.viewAll': 'ดูทั้งหมด',
  'home.tenantDistribution': 'การกระจายผู้เช่า',
  'home.success': 'สำเร็จ',
  'home.failed': 'ล้มเหลว',
  'tenants.title': 'จัดการผู้เช่า',
  'tenants.subtitle': 'จัดการการตั้งค่า โควตา และนโยบายเรียกเก็บเงิน',
  'tenants.export': 'ส่งออกรายการ',
  'tenants.create': 'ผู้เช่าใหม่',
  'tenants.total': 'ทั้งหมด',
  'tenants.unit': 'ผู้เช่า',
  'tenants.clickTip': 'คลิกแถวเพื่อดูรายละเอียด',
  'tenants.showing': 'แสดง',
  'tenants.to': '-',
  'tenants.of': 'จาก',
  'tenants.records': 'รายการ',
  'tenants.createTitle': 'ผู้เช่าใหม่',
  'tenants.createSuccess': 'สร้างผู้เช่าสำเร็จ!',
  'tenants.createFailed': 'สร้างล้มเหลว',
  'tenants.tenantName': 'ชื่อผู้เช่า',
  'tenants.subdomain': 'โดเมนย่อย',
  'tenants.contactName': 'ชื่อผู้ติดต่อ',
  'tenants.contactEmail': 'อีเมลผู้ติดต่อ',
  'tenants.planType': 'ประเภทแผน',
  'tenants.deployRegion': 'ภูมิภาคปรับใช้',
  'tenants.cancel': 'ยกเลิก',
  'tenants.createBtn': 'สร้างผู้เช่า',
  'tenants.namePlaceholder': 'เช่น: บริษัท เทค อินโนเวชัน จำกัด',
  'tenants.domainPlaceholder': 'techcorp',
  'tenants.contactPlaceholder': 'สมชาย',
  'tenants.emailPlaceholder': 'admin@company.com',
  'tenants.plan.basic': 'พื้นฐาน',
  'tenants.plan.professional': 'มืออาชีพ',
  'tenants.plan.enterprise': 'องค์กร',
  'tenants.region.east': 'จีนตะวันออก',
  'tenants.region.north': 'จีนเหนือ',
  'tenants.region.south': 'จีนใต้',
  'tenants.region.west': 'จีนตะวันตก',
  'tenantStats.total': 'ผู้เช่าทั้งหมด',
  'tenantStats.active': 'ผู้เช่าที่ใช้งาน',
  'tenantStats.totalUsers': 'ผู้ใช้ทั้งหมด',
  'tenantStats.monthlyRevenue': 'รายได้รายเดือน',
  'tenantFilters.search': 'ค้นหาชื่อ โดเมน หรือผู้ติดต่อ...',
  'tenantFilters.allPlans': 'ทุกแผน',
  'tenantFilters.allStatus': 'ทุกสถานะ',
  'tenantFilters.active': 'ใช้งาน',
  'tenantFilters.suspended': 'ระงับ',
  'tenantFilters.trial': 'ทดลอง',
  'tenantTable.info': 'ข้อมูลผู้เช่า',
  'tenantTable.plan': 'แผน',
  'tenantTable.status': 'สถานะ',
  'tenantTable.users': 'ผู้ใช้',
  'tenantTable.apiCalls': 'เรียก API',
  'tenantTable.storage': 'พื้นที่เก็บ',
  'tenantTable.region': 'ภูมิภาค',
  'tenantTable.lastActive': 'ใช้งานล่าสุด',
  'tenantTable.actions': 'การดำเนินการ',
  'tenantTable.viewDetail': 'ดูรายละเอียด',
  'tenantTable.edit': 'แก้ไข',
  'tenantTable.more': 'เพิ่มเติม',
  'tenantTable.noMatch': 'ไม่พบผู้เช่าที่ตรงกัน',
  'tenantDetail.overview': 'ภาพรวม',
  'tenantDetail.quotaMgmt': 'จัดการโควตา',
  'tenantDetail.dataIsolation': 'แยกข้อมูล',
  'tenantDetail.billing': 'เรียกเก็บเงิน',
  'tenantDetail.createdAt': 'สร้างเมื่อ',
  'tenantDetail.resourceUsage': 'การใช้ทรัพยากร',
  'tenantDetail.apiCallUsage': 'การเรียก API',
  'tenantDetail.storageUsage': 'พื้นที่เก็บ',
  'tenantDetail.userCount': 'จำนวนผู้ใช้',
  'tenantDetail.contactInfo': 'ข้อมูลติดต่อ',
  'tenantDetail.contact': 'ผู้ติดต่อ',
  'tenantDetail.email': 'อีเมล',
  'tenantDetail.deployRegion': 'ภูมิภาคปรับใช้',
  'tenantDetail.lastActive': 'ใช้งานล่าสุด',
  'tenantDetail.enabledFeatures': 'ฟีเจอร์ที่เปิดใช้',
  'tenantDetail.tags': 'แท็กผู้เช่า',
  'tenantDetail.quickActions': 'การดำเนินการด่วน',
  'tenantDetail.suspend': 'ระงับผู้เช่า',
  'tenantDetail.resume': 'เปิดใช้ผู้เช่า',
  'tenantDetail.sendNotice': 'ส่งการแจ้งเตือน',
  'tenantDetail.simulateLogin': 'จำลองการเข้าสู่ระบบ',
  'tenantDetail.exportData': 'ส่งออกข้อมูล',
  'tenantDetail.quotaSaved': 'บันทึกโควตาแล้ว',
  'tenantDetail.quotaSettings': 'ตั้งค่าโควตา',
  'tenantDetail.quotaDesc': 'ปรับขีดจำกัดทรัพยากรสำหรับผู้เช่านี้',
  'tenantDetail.maxUsers': 'ผู้ใช้สูงสุด',
  'tenantDetail.apiCallsMonth': 'เรียก API / เดือน',
  'tenantDetail.storageSpace': 'พื้นที่เก็บ',
  'tenantDetail.currentUsage': 'การใช้ปัจจุบัน',
  'tenantDetail.saveQuota': 'บันทึกการตั้งค่าโควตา',
  'tenantDetail.isolationSaved': 'บันทึกนโยบายการแยกแล้ว',
  'tenantDetail.isolationPolicy': 'นโยบายการแยกข้อมูล',
  'tenantDetail.isolationDesc': 'เลือกวิธีจัดเก็บและแยกข้อมูล',
  'tenantDetail.dedicated': 'แยกเฉพาะ',
  'tenantDetail.dedicatedDesc': 'ฐานข้อมูลเฉพาะ แยกข้อมูลสมบูรณ์ ความปลอดภัยสูงสุด',
  'tenantDetail.shared': 'แยกร่วม',
  'tenantDetail.sharedDesc': 'แชร์ฐานข้อมูล แยกด้วยความปลอดภัยระดับแถว ต้นทุนต่ำกว่า',
  'tenantDetail.recommended': 'แนะนำ',
  'tenantDetail.permissionConfig': 'การตั้งค่าสิทธิ์',
  'tenantDetail.crossTenantAccess': 'เข้าถึงข้อมูลข้ามผู้เช่า',
  'tenantDetail.crossTenantDesc': 'อนุญาตให้เข้าถึงข้อมูลสาธารณะของผู้เช่าอื่น',
  'tenantDetail.apiRateLimit': 'จำกัดอัตรา API',
  'tenantDetail.apiRateLimitDesc': 'ใช้การจำกัดอัตราสำหรับคำขอ API',
  'tenantDetail.dataExport': 'สิทธิ์ส่งออกข้อมูล',
  'tenantDetail.dataExportDesc': 'อนุญาตให้ผู้เช่านี้ส่งออกข้อมูล',
  'tenantDetail.auditAccess': 'เข้าถึงบันทึกตรวจสอบ',
  'tenantDetail.auditAccessDesc': 'อนุญาตให้ดูบันทึกตรวจสอบของตนเอง',
  'tenantDetail.saveIsolation': 'บันทึกนโยบายการแยก',
  'tenantDetail.currentPlan': 'ค่าแผนปัจจุบัน',
  'tenantDetail.perMonth': '/ เดือน',
  'tenantDetail.nextBilling': 'วันเรียกเก็บถัดไป',
  'tenantDetail.billDetail': 'รายละเอียดใบแจ้งหนี้',
  'tenantDetail.baseFee': 'ค่าแผนพื้นฐาน',
  'tenantDetail.apiCallFee': 'ค่าเรียก API',
  'tenantDetail.storageFee': 'ค่าพื้นที่เก็บ',
  'tenantDetail.supportFee': 'ค่าสนับสนุน',
  'tenantDetail.total': 'รวม',
  'tenantDetail.historyBills': 'ประวัติใบแจ้งหนี้',
  'tenantDetail.paid': 'ชำระแล้ว',
  'tenantDetail.download': 'ดาวน์โหลด',
  'tenantDetail.feature.aiModels': 'โมเดล AI',
  'tenantDetail.feature.apiAccess': 'เข้าถึง API',
  'tenantDetail.feature.advancedAnalytics': 'วิเคราะห์ขั้นสูง',
  'tenantDetail.feature.basicAnalytics': 'วิเคราะห์พื้นฐาน',
  'tenantDetail.feature.customDomain': 'โดเมนกำหนดเอง',
  'tenantDetail.feature.sso': 'SSO',
  'tenantDetail.feature.whiteLabel': 'ไวท์เลเบล',
  'users.title': 'จัดการผู้ใช้และสิทธิ์',
  'users.subtitle': 'จัดการบัญชีผู้ใช้และสิทธิ์ของทุกผู้เช่า',
  'users.addUser': 'เพิ่มผู้ใช้',
  'users.totalUsers': 'ผู้ใช้ทั้งหมด',
  'users.activeUsers': 'ผู้ใช้ที่ใช้งาน',
  'users.admins': 'ผู้ดูแล',
  'users.developers': 'นักพัฒนา',
  'users.loading': 'กำลังโหลด...',
  'userFilters.search': 'ค้นหาชื่อ อีเมล หรือผู้เช่า...',
  'userFilters.allRoles': 'ทุกบทบาท',
  'userFilters.admin': 'ผู้ดูแล',
  'userFilters.user': 'ผู้ใช้ทั่วไป',
  'userFilters.developer': 'นักพัฒนา',
  'userFilters.allStatus': 'ทุกสถานะ',
  'userFilters.active': 'ใช้งาน',
  'userFilters.inactive': 'ไม่ได้ใช้งาน',
  'userFilters.moreFilters': 'ตัวกรองเพิ่มเติม',
  'userTable.user': 'ผู้ใช้',
  'userTable.tenant': 'ผู้เช่า',
  'userTable.role': 'บทบาท',
  'userTable.status': 'สถานะ',
  'userTable.lastLogin': 'เข้าสู่ระบบล่าสุด',
  'userTable.actions': 'การดำเนินการ',
  'userTable.role.admin': 'ผู้ดูแล',
  'userTable.role.user': 'ผู้ใช้',
  'userTable.role.developer': 'นักพัฒนา',
  'userTable.status.active': 'ใช้งาน',
  'userTable.status.inactive': 'ไม่ได้ใช้งาน',
  'resources.title': 'การตั้งค่าบริการ',
  'resources.subtitle': 'จัดการโมเดล AI คีย์ API และการรวมบริการ',
  'resources.refresh': 'รีเฟรช',
  'resources.addConfig': 'เพิ่มการตั้งค่า',
  'resources.totalConfigs': 'การตั้งค่าทั้งหมด',
  'resources.active': 'ใช้งาน',
  'resources.categories': 'หมวดหมู่',
  'resources.secrets': 'ความลับ',
  'resources.addTitle': 'เพิ่มการตั้งค่าใหม่',
  'resources.category': 'หมวดหมู่',
  'resources.configKey': 'คีย์การตั้งค่า',
  'resources.displayName': 'ชื่อที่แสดง',
  'resources.value': 'ค่า',
  'resources.description': 'คำอธิบาย',
  'resources.secretValue': 'ค่าลับ',
  'resources.type': 'ประเภท:',
  'resources.save': 'บันทึก',
  'resources.cancel': 'ยกเลิก',
  'resources.create': 'สร้าง',
  'resources.configs': 'การตั้งค่า',
  'resources.items': 'รายการ',
  'resources.notConfigured': 'ยังไม่ได้ตั้งค่า',
  'resources.noConfigs': 'ไม่พบการตั้งค่า',
  'resources.running': 'กำลังทำงาน',
  'resources.maintenance': 'บำรุงรักษา',
  'resources.endpoint': 'เอนด์พอยต์',
  'resources.usageTenants': 'ผู้เช่าที่ใช้',
  'resources.usageUnit': 'ราย',
  'resources.usage': 'การใช้งาน',
  'resources.configure': 'ตั้งค่า',
  'resources.stats': 'สถิติ',
  'resources.modelType': 'ประเภท',
  'resources.version': 'เวอร์ชัน',
  'resources.callCount': 'จำนวนเรียก',
  'resources.cost': 'ต้นทุน',
  'resources.apiKey': 'คีย์ API',
  'resources.edit': 'แก้ไข',
  'resources.usageStats': 'สถิติการใช้',
  'settings.title': 'ตั้งค่าระบบ',
  'settings.subtitle': 'จัดการการตั้งค่าทั่วไป นโยบายความปลอดภัย และภาษา',
  'settings.tab.general': 'ทั่วไป',
  'settings.tab.services': 'บริการ',
  'settings.tab.security': 'ความปลอดภัย',
  'settings.tab.notification': 'การแจ้งเตือน',
  'settings.tab.billing': 'แผนเรียกเก็บเงิน',
  'settings.tab.locale': 'ภาษา',
  'settings.systemInfo': 'ข้อมูลระบบ',
  'settings.version': 'เวอร์ชัน',
  'settings.environment': 'สภาพแวดล้อม',
  'settings.production': 'โปรดักชัน',
  'settings.availability': 'ความพร้อมใช้งาน',
  'settings.lastBackup': 'สำรองข้อมูลล่าสุด',
  'settings.todayAt': 'วันนี้ 03:00',
  'general.platformInfo': 'ข้อมูลแพลตฟอร์ม',
  'general.platformName': 'ชื่อแพลตฟอร์ม',
  'general.platformUrl': 'URL แพลตฟอร์ม',
  'general.supportEmail': 'อีเมลสนับสนุน',
  'general.timezone': 'เขตเวลา',
  'general.dateFormat': 'รูปแบบวันที่',
  'general.maxTenants': 'ผู้เช่าสูงสุด / แผน',
  'general.sessionMaintenance': 'เซสชันและบำรุงรักษา',
  'general.sessionTimeout': 'หมดเวลาเซสชัน',
  'general.sessionTimeoutDesc': 'ออกจากระบบอัตโนมัติเมื่อไม่มีกิจกรรม',
  'general.minutes': 'นาที',
  'general.maintenanceMode': 'โหมดบำรุงรักษา',
  'general.maintenanceDesc': 'ผู้ใช้จะเห็นหน้าบำรุงรักษาเมื่อเปิดใช้',
  'general.maintenanceWarning': 'โหมดบำรุงรักษาเปิดอยู่ ผู้ใช้ทั้งหมดไม่สามารถเข้าถึงแพลตฟอร์มได้',
  'general.reset': 'รีเซ็ต',
  'general.save': 'บันทึกการตั้งค่า',
  'general.saved': 'บันทึกแล้ว',
  'security.authPolicy': 'นโยบายการยืนยันตัวตน',
  'security.mfa': 'บังคับ MFA',
  'security.mfaDesc': 'บัญชีผู้ดูแลทั้งหมดต้องเปิดใช้ MFA',
  'security.sso': 'SSO',
  'security.ssoProtocol': 'โปรโตคอลปัจจุบัน',
  'security.passwordPolicy': 'นโยบายรหัสผ่าน',
  'security.minLength': 'ความยาวขั้นต่ำ',
  'security.chars': 'ตัวอักษร',
  'security.expireDays': 'อายุรหัสผ่าน',
  'security.days': 'วัน',
  'security.maxAttempts': 'ล็อกอินผิดสูงสุด',
  'security.times': 'ครั้ง',
  'security.lockoutDuration': 'ระยะเวลาล็อก',
  'security.ipWhitelist': 'รายการ IP ที่อนุญาต',
  'security.ipPlaceholder': 'ป้อน IP หรือ CIDR เช่น 192.168.1.0/24',
  'security.add': 'เพิ่ม',
  'security.ipWhitelistDesc': 'เมื่อเปิดใช้ เฉพาะ IP ที่อนุญาตเท่านั้นที่สามารถเข้าถึงแผงผู้ดูแล',
  'security.auditLog': 'บันทึกตรวจสอบ',
  'security.retentionDays': 'วันเก็บบันทึก',
  'security.retentionDesc': 'บันทึกที่เก่ากว่าจะถูกลบอัตโนมัติ',
  'security.reset': 'รีเซ็ต',
  'security.save': 'บันทึกการตั้งค่า',
  'security.saved': 'บันทึกแล้ว',
  'notification.channels': 'ช่องทางการแจ้งเตือน',
  'notification.email': 'การแจ้งเตือนอีเมล',
  'notification.emailDesc': 'ส่งการแจ้งเตือนและรายงานทางอีเมล',
  'notification.sms': 'การแจ้งเตือน SMS',
  'notification.smsDesc': 'ส่งการแจ้งเตือนเร่งด่วนทาง SMS',
  'notification.webhook': 'Webhook',
  'notification.webhookDesc': 'ส่งเหตุการณ์ไปยัง URL ที่ระบุ',
  'notification.webhookUrl': 'URL Webhook',
  'notification.alertEvents': 'เหตุการณ์แจ้งเตือน',
  'notification.tenantCreate': 'ผู้เช่าใหม่ลงทะเบียน',
  'notification.tenantCreateDesc': 'แจ้งเตือนเมื่อผู้เช่าใหม่ลงทะเบียน',
  'notification.quotaExceed': 'โควตาเกิน',
  'notification.quotaExceedDesc': 'แจ้งเตือนเมื่อ API เกิน 90%',
  'notification.loginFail': 'ล็อกอินล้มเหลว',
  'notification.loginFailDesc': 'แจ้งเตือนเมื่อล็อกอินผิดถึงเกณฑ์',
  'notification.systemError': 'ข้อผิดพลาดระบบ',
  'notification.systemErrorDesc': 'แจ้งเตือนทันทีเมื่อเกิดข้อผิดพลาดร้ายแรง',
  'notification.scheduledReport': 'รายงานตามกำหนด',
  'notification.dailyReport': 'รายงานรายวัน',
  'notification.dailyReportDesc': 'ส่งสรุปข้อมูลรายวัน',
  'notification.sendTime': 'เวลาส่ง',
  'notification.recipients': 'ผู้รับรายงาน',
  'notification.emailPlaceholder': 'ป้อนอีเมล',
  'notification.addBtn': 'เพิ่ม',
  'notification.reset': 'รีเซ็ต',
  'notification.save': 'บันทึกการตั้งค่า',
  'notification.saved': 'บันทึกแล้ว',
  'billing.saved': 'บันทึกแผนแล้ว',
  'billing.totalPlans': 'แผนทั้งหมด',
  'billing.activePlans': 'แผนที่ใช้งาน',
  'billing.highestPrice': 'ราคาสูงสุด',
  'billing.editing': 'กำลังแก้ไข',
  'billing.cancel': 'ยกเลิก',
  'billing.save': 'บันทึก',
  'billing.planName': 'ชื่อแผน',
  'billing.monthlyFee': 'ค่ารายเดือน (CNY)',
  'billing.apiCallsMonth': 'เรียก API / เดือน',
  'billing.storageSpace': 'พื้นที่เก็บ (GB)',
  'billing.maxUsers': 'ผู้ใช้สูงสุด',
  'billing.supportType': 'ประเภทสนับสนุน',
  'billing.disabled': 'ปิดใช้งาน',
  'billing.perMonth': '/ เดือน',
  'billing.edit': 'แก้ไข',
  'billing.apiLabel': 'เรียก API',
  'billing.storageLabel': 'พื้นที่เก็บ',
  'billing.usersLabel': 'ผู้ใช้',
  'billing.supportLabel': 'สนับสนุน',
  'locale.defaultLang': 'ตั้งค่าภาษาเริ่มต้น',
  'locale.platformDefault': 'ภาษาเริ่มต้นของแพลตฟอร์ม',
  'locale.platformDefaultDesc': 'ภาษาที่ใช้เมื่อผู้ใช้ใหม่เยี่ยมชมครั้งแรก',
  'locale.fallbackLang': 'ภาษาสำรอง',
  'locale.fallbackLangDesc': 'ใช้เมื่อไม่มีคำแปล',
  'locale.autoDetect': 'ตรวจจับภาษาเบราว์เซอร์อัตโนมัติ',
  'locale.autoDetectDesc': 'เปลี่ยนภาษาอัตโนมัติตามการตั้งค่าเบราว์เซอร์',
  'locale.tenantOverride': 'อนุญาตผู้เช่ากำหนดภาษาเอง',
  'locale.tenantOverrideDesc': 'ผู้เช่าสามารถแทนที่ภาษาเริ่มต้นได้',
  'locale.langManagement': 'จัดการชุดภาษา',
  'locale.enabled': 'เปิดใช้',
  'locale.default': 'เริ่มต้น',
  'locale.translationCoverage': 'ครอบคลุมการแปล',
  'locale.cannotDisable': 'ไม่สามารถปิดภาษาเริ่มต้น',
  'locale.coverageNote': 'หมายเหตุเกี่ยวกับครอบคลุม',
  'locale.coverageDesc': 'ชุดภาษาที่ครอบคลุมต่ำกว่า 80% อาจแสดงบาง UI เป็นภาษาสำรอง',
  'locale.save': 'บันทึกการตั้งค่า',
  'locale.saved': 'บันทึกแล้ว',
  'serviceConfigs.title': 'การตั้งค่าบริการ',
  'serviceConfigs.subtitle': 'จัดการโมเดล AI คีย์ API และการรวมบริการภายนอก',
  'serviceConfigs.refresh': 'รีเฟรช',
  'audit.title': 'บันทึกตรวจสอบ',
  'audit.subtitle': 'บันทึกการดำเนินการและการตรวจสอบความปลอดภัย',
  'audit.totalLogs': 'บันทึกทั้งหมด',
  'audit.totalLogsDesc': 'บันทึกทั้งหมด',
  'audit.successOps': 'การดำเนินการสำเร็จ',
  'audit.successRate': 'อัตราสำเร็จ',
  'audit.failedOps': 'การดำเนินการล้มเหลว',
  'audit.failedDesc': 'ต้องให้ความสนใจ',
  'audit.todayOps': 'การดำเนินการวันนี้',
  'audit.todayDesc': 'กิจกรรมวันนี้',
  'audit.tenant': 'ผู้เช่า',
  'audit.allTenants': 'ผู้เช่าทั้งหมด',
  'audit.actionType': 'ประเภทการดำเนินการ',
  'audit.allActions': 'ทุกการดำเนินการ',
  'audit.status': 'สถานะ',
  'audit.allStatus': 'ทุกสถานะ',
  'audit.success': 'สำเร็จ',
  'audit.failed': 'ล้มเหลว',
  'audit.timeRange': 'ช่วงเวลา',
  'audit.allTime': 'ทุกช่วงเวลา',
  'audit.today': 'วันนี้',
  'audit.last7days': '7 วันล่าสุด',
  'audit.last30days': '30 วันล่าสุด',
  'audit.keyword': 'ค้นหาคีย์เวิร์ด',
  'audit.keywordPlaceholder': 'ค้นหาผู้ใช้ การดำเนินการ ทรัพยากร...',
  'audit.found': 'พบ',
  'audit.records': 'รายการ',
  'audit.clearFilter': 'ล้างตัวกรอง',
  'audit.time': 'เวลา',
  'audit.user': 'ผู้ใช้',
  'audit.action': 'การดำเนินการ',
  'audit.resource': 'ทรัพยากร',
  'audit.ipAddress': 'ที่อยู่ IP',
  'audit.actions': 'การดำเนินการ',
  'audit.viewDetail': 'ดูรายละเอียด',
  'audit.showing': 'แสดง',
  'audit.prevPage': 'ก่อนหน้า',
  'audit.nextPage': 'ถัดไป',
  'audit.detailTitle': 'รายละเอียดการดำเนินการ',
  'audit.logId': 'ID บันทึก',
  'audit.operationTime': 'เวลาดำเนินการ',
  'audit.operationStatus': 'สถานะดำเนินการ',
  'audit.tenantInfo': 'ข้อมูลผู้เช่า',
  'audit.tenantId': 'ID ผู้เช่า',
  'audit.tenantName': 'ชื่อผู้เช่า',
  'audit.operationUser': 'ผู้ดำเนินการ',
  'audit.userId': 'ID ผู้ใช้',
  'audit.userName': 'ชื่อผู้ใช้',
  'audit.operationInfo': 'ข้อมูลการดำเนินการ',
  'audit.operationType': 'ประเภทการดำเนินการ',
  'audit.operationResource': 'ทรัพยากร',
  'audit.operationDetail': 'รายละเอียด',
  'audit.networkInfo': 'ข้อมูลเครือข่าย',
  'audit.userAgent': 'User Agent',
  'reports.title': 'รายงานและการวิเคราะห์',
  'reports.subtitle': 'การวิเคราะห์ข้อมูลหลายมิติและรายงานภาพ',
  'reports.last7days': '7 วันล่าสุด',
  'reports.last30days': '30 วันล่าสุด',
  'reports.last90days': '90 วันล่าสุด',
  'reports.apiTrend': 'แนวโน้มเรียก API',
  'reports.revenueCompare': 'เปรียบเทียบรายได้',
  'reports.resourceUsage': 'การใช้ทรัพยากร',
  'reports.userActivity': 'กิจกรรมผู้ใช้',
  'reports.activeUsers': 'ผู้ใช้ที่ใช้งาน',
  'reports.newUsers': 'ผู้ใช้ใหม่',
  'reports.tenantSummary': 'สรุปข้อมูลผู้เช่า',
  'reports.tenantName': 'ชื่อผู้เช่า',
  'reports.apiCalls': 'เรียก API',
  'reports.storageUsage': 'การใช้พื้นที่เก็บ',
  'reports.userCount': 'ผู้ใช้',
  'reports.revenue': 'รายได้',
  'reports.quotaUsage': 'การใช้โควตา',
  'langSwitcher.title': 'ภาษา / Language',
};
